module.exports = __webpack_public_path__ + "static/media/azure_fundamentals.c5a04932.png";